// extracted by mini-css-extract-plugin
module.exports = {"about":"Home_about__30NEI"};